import { createIcon } from '@chakra-ui/icons'

const XLSIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#6AAC46"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        XLS
      </text>
      <path
        d="M59.4 41.1H18.2c-1.4-.1-2.7 1-2.8 2.5V73c.1 1.4 1.3 2.6 2.8 2.5h41.1c1.4.1 2.7-1 2.8-2.5V43.5c-.1-1.4-1.3-2.5-2.7-2.4zM32.1 63.6v-7h13.4v7H32.1zm13.4 2.3V73H32.1v-7.1h13.4zm0-18.7v7H32.1v-7h13.4zm14.2 0v7H47.9v-7h11.8zm-30 7H17.8v-7h11.9v7zm-11.9 2.3h11.9v7H17.8v-7zm30.1 0h11.9v7H47.9v-7zM18.2 43.4h41.1c.1 0 .3 0 .4.1v1.3H17.8v-1.2c.1-.1.3-.2.4-.2zM17.8 73v-7h11.9v7H18.2c-.1.1-.2 0-.4 0zm41.5.1H47.9V66h11.9v7c-.2.1-.3.1-.5.1z"
        fill="#F2F2F4"
      />
    </>
  ),
})

export default XLSIcon
